// Internal imports (Redux slice)
import { fetchNotesStart, fetchNotesSuccess, fetchNotesFailure } from './notesSlice';

// External imports (Libraries)
import { takeLatest, put, call, CallEffect, PutEffect } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { PayloadAction } from '@reduxjs/toolkit';

// API Services

// Models
import { NotesByContractRequest } from '@/api/models/BaseRequest';
import { Notes } from '@/api/models/Notes';
import { ContractDetailService } from '@/api/services/contractDetailService';

/**
 * Saga to fetch notes from the API.
 * @param action - Payload containing contractid.
 */
function* fetchNotesSaga(
  action: PayloadAction<NotesByContractRequest>,
): Generator<CallEffect<Notes[]> | PutEffect, void, Notes[]> {
  try {
    const notes: Notes[] = yield call(ContractDetailService.fetchNotesDetails, action.payload);

    // Dispatch success action with retrieved notes
    yield put(fetchNotesSuccess(notes));
  } catch (error: unknown) {
    // Handle errors and dispatch failure action
    const errorMessage = error instanceof Error ? error.message : 'Fetching notes failed';
    yield put(fetchNotesFailure(errorMessage));
  }
}

/**
 * Watcher saga to listen for fetchNotesStart action.
 */
export function* watchNotes(): SagaIterator {
  yield takeLatest(fetchNotesStart.type, fetchNotesSaga);
}
